export enum GenericInfoPayloadType {
	MassRequestUpdate = 1
}
